import * as React from 'react';
import * as I18n from 'i18n-js';
import { V3 } from '../api_request';

import ComparisonShoppingPage from '../discovery/csp/comparison_shopping_page';
import URLHelpers from '../shared/url_helpers';

import CSPSquareCard from '../discovery/csp/csp_square_card';
import OverflowingRow from '@reverbdotcom/commons/dist/components/overflowing_row';
import Tiles from '@reverbdotcom/commons/dist/components/tiles';

const COMPONENT_NAME = 'CSPMiniGrid';

interface State {
  pages: ComparisonShoppingPage[];
}

interface Props {
  slug: string;
  heading: string;
}

export default class CSPMiniGridEmbed extends React.Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      pages: [],
    };
  }

  componentDidMount() {
    const req = V3.get(URLHelpers.cspsEmbedPath(), {
      curated_set_slug: this.props.slug,
      per_page: 6,
    });

    req.then((response) => {
      const pages = response
        .comparison_shopping_pages
        .map(page => new ComparisonShoppingPage(page));

      this.setState({ pages });
    });
  }

  collectionLink() {
    return (
      <a href={`/collection/${this.props.slug}`}>
        {I18n.t('discovery.cspMiniGridEmbed.seeMore')}
      </a>
    );
  }

  render() {
    return (
      <OverflowingRow
        title={this.props.heading}
        action={this.collectionLink()}
        collectionCount={this.state.pages.length}
      >
        <Tiles
          placeholder={<CSPSquareCard />}
          singleRow
        >
          {this.state.pages.map((page, idx) => (
            <CSPSquareCard
              trackName={COMPONENT_NAME}
              key={idx}
              page={page}
              position={idx + 1}
            />
          ))}
        </Tiles>
      </OverflowingRow>
    );
  }
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/embeds/csp_mini_grid_embed.tsx